<template>
  <div id="formFolio" class="w-full mx-auto px-4 md:px-0">
    <!-- Resend Access Code Form -->
    <div class="flex flex-col w-full mx-auto">
      <div class="title uppercase text-center font-bold">
        {{ $t("Forms.still_received_activation_code") }}
      </div>
      <p class="text-sm mt-3 mb-3 w-full relative text-center">
        {{ $t('Forms.new_activate_code_description') }}
      </p>

      <p class="py-3">
        {{ $t('Forms.if_you_have_account') }}
        <a class="cursor-pointer text-newxcaret-blue" @click.prevent="setModalAuth(1)">
          {{ $t("Forms.login") }}
        </a>
      </p>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(resendAccessCode)" class="flex flex-col w-full pt-2 pb-6 relative">
          <ValidationProvider rules="required|email" v-slot="{ errors }">
            <label class="font-bold" :for="$t('Forms.email')">{{
              $t('Forms.email')
              }}</label>
            <input type="text" :placeholder="$t('Forms.email')" v-model="form.email" :id="$t('Forms.email')"
              :name="$t('Forms.email')" class="
                  w-full
                  h-10
                  p-3
                  my-2
                  border border-newxcaret-blue
                  bg-white
                  rounded-lg
                " />
            <p class="txt-error text-red text-xs italic">
              {{ errors[0] }}
            </p>
          </ValidationProvider>

          <div class="flex flex-col md:flex-row items-center">
            <button type="submit" class="
                  flex
                  w-full
                  items-center
                  justify-center
                  w-full
                  mt-4
                  p-2
                  bg-yellow-photo
                  rounded-full
                  text-sm
                  font-semibold
                ">
              {{ $t('Forms.send') }}
            </button>
          </div>
          <p class="italic mt-4">
            <span class="text-red font-bold">*</span><i>{{ $t('Forms.new_activate_code_note') }}</i>
          </p>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import "@validators/index";

export default {
  props: [],
  mixins: [],
  components: {},
  data: () => ({
    loading: false,
  }),
  watch: {},
  computed: {
    // Acceder al state de 'auth' module
    ...mapState('auth', ['modalAuth']),

    // Usar getters de 'auth' module
    ...mapGetters('auth', ['getModalAuth']),
  },
  methods: {
    // Usar acciones de 'auth' module
    ...mapActions('auth', ['setModalAuth'])
  },
  mounted() {},
};
</script>